module.exports = __webpack_public_path__ + "media/images/claim_profile/leads-597ffc5f0f22f03590aa06fe65959cd1.png";